import Model from '@/store/plugins/orm/Model'
import Money from '@/wrappers/Money';

export class CashSale extends Model {
    static get entity () {
        return 'cash_sales'
    }

    static fields () {
        return {
            id: this.attr(null),
            user_id: this.attr(null),
            date: this.attr(null),
            paid_at_date: this.attr(null),
            amount: this.attr('0.0000', value => _.round(value, 4).toFixed(4)),
        }
    }

    getAmount() {
        return Money.parse(this.amount);
    }
}

export default CashSale
